var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircleColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar_2_",
    "data-name": "dollar (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33386",
    "data-name": "Path 33386",
    d: "M10.5,21A10.5,10.5,0,0,1,3.075,3.075,10.5,10.5,0,0,1,17.925,17.925,10.431,10.431,0,0,1,10.5,21Zm0-19.688A9.188,9.188,0,1,0,19.687,10.5,9.2,9.2,0,0,0,10.5,1.312Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33387",
    "data-name": "Path 33387",
    d: "M186.953,101.906a1.641,1.641,0,1,1,1.641-1.641.656.656,0,0,0,1.313,0,2.958,2.958,0,0,0-2.3-2.879v-.731a.656.656,0,0,0-1.312,0v.731a2.953,2.953,0,0,0,.656,5.832,1.641,1.641,0,1,1-1.641,1.641.656.656,0,0,0-1.312,0,2.958,2.958,0,0,0,2.3,2.879v.731a.656.656,0,0,0,1.313,0v-.731a2.953,2.953,0,0,0-.656-5.832Z",
    transform: "translate(-176.453 -92.063)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircleColored);
export default __webpack_public_path__ + "static/media/dollar-circle-colored.a609103f237b417b4c21143329ae8c79.svg";
export { ForwardRef as ReactComponent };